import React from "react";
import {
    createGenerateClassName,
    StylesProvider,
    ThemeProvider
} from "@material-ui/styles";
import { SnackBarProviderWrapper } from "js/react/components";
import { CssBaseline } from "@material-ui/core";
import theme from "../../react/styles/Theme";
import { FileManagerProps } from "./components/MediaManagement";

import MediaManagementDialog from "js/react/scenes/components/MediaManagementDialog";
import { library } from "@fortawesome/fontawesome-svg-core";

import {
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faStore,
    faChevronDown,
    faHomeLgAlt,
    faTimes,
    faTimesCircle,
    faPhotoVideo as faLightPhotoVideo,
    faFolder as faLightFolder,
    faBorderAll,
    faLevelUpAlt,
    faCheckCircle,
    faPlus,
    faTvRetro
} from "@fortawesome/pro-light-svg-icons";
import {
    faPlay,
    faEdit,
    faStop,
    faPause,
    faStepForward,
    faImage,
    faFolder,
    faEraser,
    faPowerOff,
    faTrash,
    faStepBackward,
    faDownload,
    faExternalLink,
    faFilm,
    faMousePointer
} from "@fortawesome/pro-solid-svg-icons";
import {
    faPhotoVideo,
    faBars,
    faPen,
    faCreditCard
} from "@fortawesome/pro-regular-svg-icons";
import { faEllipsisVAlt, faTrashAlt } from "@fortawesome/pro-duotone-svg-icons";

library.add(
    faTvRetro,
    faCreditCard,
    faLevelUpAlt,
    faPen,
    faHomeLgAlt,
    faPowerOff,
    faCheckCircle,
    faStore,
    faLightPhotoVideo,
    faDownload,
    faPlus,
    faEraser,
    faEdit,
    faStop,
    faLightFolder,
    faTrashAlt,
    faTrash,
    faFolder,
    faStepForward,
    faTimes,
    faChevronDown,
    faImage,
    faBorderAll,
    faPause,
    faBars,
    faStepBackward,
    faTimesCircle,
    faPhotoVideo,
    faPlay,
    faEllipsisVAlt,
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faExternalLink,
    faFilm,
    faMousePointer
);

const generateClassName = createGenerateClassName();

export const App = (props: FileManagerProps) => {
    return (
        <StylesProvider generateClassName={generateClassName}>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <SnackBarProviderWrapper>
                    <MediaManagementDialog {...props} />
                </SnackBarProviderWrapper>
            </ThemeProvider>
        </StylesProvider>
    );
};

export default App;
